// require('turbolinks').start()
// require('@rails/activestorage').start()
// require('channels')

import '@/shared/'
import '@/app/'
import '@/app/support.js'
require('@rails/ujs').start()
